// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__13GaZ","col":"Table_col__1k27K","fulfillmentStatus":"Table_fulfillmentStatus__3XDA6","emailCol":"Table_emailCol__3bFVS"};